import track from './track'

$('.cta-link a').click( function(e) {
    let category = $(this).parents('.cta-link').data('category')
    let label = $(this).data('label')
    let href = $(this).attr('href').replace(/^[a-z:]*\/\/([a-z\.:0-9]*)/, '')

    track.event({
        eventCategory: category ?? "link",
        eventAction: "click",
        eventLabel: label ?? href
    })
})
